module.exports = __webpack_public_path__ + "img/addon-workflow-automation.baa39fdf.png";